import type { GraphData } from "../types/gameTypes";
import type { PersistentGameState } from "../services/UnifiedDataStore";

/** True iff every supplied word is a node in the current graph. Empty → true. */
export const gameWordsInGraph = (words: string[], graph: GraphData): boolean =>
  words.every((w) => Object.prototype.hasOwnProperty.call(graph, w));

/**
 * A persisted in-progress game is valid for the current graph when — whenever the
 * current vocab_hash is known — its stamped vocab_hash is present and equal
 * (vocab-v2 §5.3), AND all of its words are current nodes. Saves from before the
 * stamp (no vocabHash) are therefore rejected once the current hash is known.
 */
export const isCurrentGameValid = (
  game: PersistentGameState,
  graph: GraphData,
  currentVocabHash: string | null,
): boolean => {
  if (currentVocabHash && game.vocabHash !== currentVocabHash) {
    return false;
  }
  const words = [
    game.startWord,
    game.targetWord,
    game.currentWord,
    ...game.playerPath,
  ].filter((w): w is string => typeof w === "string" && w.length > 0);
  return gameWordsInGraph(words, graph);
};
